import { render } from "./PRPMicroneedlingFacialContentEn.vue?vue&type=template&id=1fdec667&scoped=true"
import script from "./PRPMicroneedlingFacialContentEn.vue?vue&type=script&lang=js"
export * from "./PRPMicroneedlingFacialContentEn.vue?vue&type=script&lang=js"

import "./PRPMicroneedlingFacialContentEn.vue?vue&type=style&index=0&id=1fdec667&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fdec667"]])

export default __exports__